import { combineReducers } from 'redux';

import auth from './authReducer';
import quizRed from './quizReducer';
import courseRed from './courseReducer';

const rootReducer = combineReducers({
    auth,
    quizRed,
    courseRed
});
  
export default rootReducer;